import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Fullbleed } from '@/contexts/fullbleed';

/**
 * Parent route for the Recurring Jobs settings surface. The redesigned single
 * page (the index child) owns its own chrome, so this layout is now just a
 * full-bleed passthrough — the old per-tab strip was retired in favour of the
 * one-page "life of a contract + six moments" view.
 */
export const Route = createFileRoute('/_dashboard/dashboard/settings/contracts')({
  component: ContractsSettingsLayout,
});

function ContractsSettingsLayout() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Fullbleed />
      <Outlet />
    </div>
  );
}
